// PARAQTA — Premium Lock Modal (Stage 6.9.3).
// 4 variants: group-join, quote-limit, ai-chat, wrapped.
// Brand rule: "Жан дос" / "Жан досы" дефиссіз.

import { show } from '../../core/router.js';

const LOCK_VARIANTS = {
  'group-join': {
    icon: 'lock',
    title: 'PARAQTA-ның Жан досы бол',
    desc: 'Клубқа қосылу енді тегін — жаңарт та кір',
  },
  'quote-limit': {
    icon: 'bookmark-off',
    title: 'Айлық дәйексөз шегі',
    desc: 'Жан дос — шексіз дәйексөз + PDF экспорт',
  },
  'ai-chat': {
    icon: 'message-circle-off',
    title: 'AI-мен сұхбат',
    desc: 'Жан дос — шексіз AI чат',
  },
  'wrapped': {
    icon: 'sparkles',
    title: 'Айлық · Жылдық — Жан дос',
    desc: 'Апта-демо тегін көрсетілді. Айлық/жылдық толық аналитика — Жан дос мүмкіндігі.',
  },
};

function esc(s) {
  if (s == null) return '';
  return String(s).replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}

export function showPremiumLockModal(variant = 'group-join', opts = {}) {
  // 31.10 Apple 3.1.1: қолданбада сатып алуға шақыратын терезе шықпайды
  if (/PARAQTA-App\//.test(navigator.userAgent || '')) return;
  const config = LOCK_VARIANTS[variant] || LOCK_VARIANTS['group-join'];

  // Существующий modal жою (race-condition care)
  const existing = document.getElementById('premium-lock-modal');
  if (existing) existing.remove();

  const extraHtml = opts.extra
    ? `<div class="pl-modal-extra">${esc(opts.extra)}</div>`
    : '';

  const modal = document.createElement('div');
  modal.id = 'premium-lock-modal';
  modal.className = 'pl-modal-overlay';
  modal.innerHTML = `
    <div class="pl-modal" role="dialog" aria-modal="true" aria-label="${esc(config.title)}">
      <button class="pl-modal-close" data-pl-action="close" aria-label="Жабу">
        <i class="ti ti-x"></i>
      </button>

      <div class="pl-modal-icon">
        <i class="ti ti-${esc(config.icon)}"></i>
      </div>

      <h3 class="pl-modal-title">${esc(config.title)}</h3>
      <p class="pl-modal-desc">${esc(config.desc)}</p>

      ${extraHtml}

      <div class="pl-modal-actions">
        <button class="pl-cta-primary" data-pl-action="goto-jandos">
          <i class="ti ti-feather"></i>
          PARAQTA-ның Жан досы бол
        </button>
        <button class="pl-cta-secondary" data-pl-action="close">
          Кейінге
        </button>
      </div>

      <div class="pl-modal-trust">
        <span><i class="ti ti-clock"></i> 7 күн тегін</span>
        <span><i class="ti ti-x-circle"></i> Кез келген уақытта тоқтату</span>
      </div>
    </div>
  `;

  document.body.appendChild(modal);
  document.body.style.overflow = 'hidden';

  function close() {
    modal.remove();
    document.body.style.overflow = '';
  }

  modal.addEventListener('click', (e) => {
    if (e.target === modal) { close(); return; }
    const action = e.target.closest('[data-pl-action]')?.dataset.plAction;
    if (action === 'close') {
      close();
    } else if (action === 'goto-jandos') {
      close();
      try { show('jandos'); }
      catch (_) { window.location.hash = '#jandos'; }
    }
  });

  // ESC жабу
  const onKey = (e) => {
    if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onKey); }
  };
  document.addEventListener('keydown', onKey);

  return { close };
}
